import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-16 xl:gap-30',

    cart: '',

    common: 'flex w-full flex-col',
    top: 'flex flex-col gap-3 lg:gap-6',
    delivery: '',

    sidebar: 'flex h-min w-full flex-col gap-8 max-xl:w-full',
    sidebarInner: '',
    samplesBanner: '',
    bonuses: ''
  },
  variants: {
    variant: {
      checkout: {
        common: 'flex-1 gap-6 lg:w-[60%]',
        cart: 'flex flex-col gap-8 lg:flex-row xl:gap-16',
        sidebar:
          'lg-w-[30%] mt-0 flex h-min w-full flex-1 flex-col gap-8 bg-white p-6 max-xl:w-full md:p-8 lg:mt-[62px] lg:max-w-[472px]'
      },
      cartDrawer: {
        common: 'gap-6 lg:gap-8',
        cart: 'relative flex flex-col gap-[64px]',
        sidebar: 'flex h-min w-full flex-col gap-8 max-xl:w-full'
      }
    }
  }
});
